module.exports = __webpack_public_path__ + "img/bg-a8dc1d.png";